import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export async function getUserWiseAttendance(userId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETUSERATTENDANCEBYID + `?id=${userId}&start_date=&end_date=`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDateWiseAttendance(userId: string,from:string,to:string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETUSERATTENDANCEBYID + `?id=${userId}&start_date=${from}&end_date=${to}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}


export async function getAllUserWiseAttendance() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLUSERATTENDANCE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}



export async function getLeave(userId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEELEAVEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function attendanceApprove(
  userId: string,
  id: string,
  status: any
) {
  const body = {
    userId: userId,
    id: id,
    status: status,
  };
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.ATTENDANCEAPPROVE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}


